"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzIcon = _interopRequireDefault(require("./../OzIcon/OzIcon.js"));

var _consts = require("./../consts.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__Wrapper",
  componentId: "sc-tq1qi-0"
})(["\n  text-align: left;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"]);

var Container = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__Container",
  componentId: "sc-tq1qi-1"
})(["\n  position: relative;\n  display: block;\n  width: ", ";\n  max-width: 100%;\n\n  border-radius: 4px;\n  // border: 1px solid transparent;\n\n  ", "\n"], function (props) {
  return props.width;
}, function (props) {
  return props.isFocus ? "\n    -webkit-box-shadow: 0px 0px 0px 1px ".concat(_consts.CHETWODEBLUE, ";\n    -moz-box-shadow: 0px 0px 0px 1px ").concat(_consts.CHETWODEBLUE, ";\n    box-shadow: 0px 0px 0px 1px ").concat(_consts.CHETWODEBLUE, ";\n    // border: 1px solid ").concat(_consts.CHETWODEBLUE, ";\n  ") : null;
});

var Selected = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__Selected",
  componentId: "sc-tq1qi-2"
})(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n  padding: 0px 30px 0px 10px;\n  cursor: pointer;\n  height: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  letter-spacing: inherit;\n  font-size: 12px;\n  box-sizing: border-box;\n  outline: none !important;\n\n  border-radius: 4px;\n\n  ", "\n\n  ", ";\n"], function (props) {
  return props.height;
}, function (props) {
  return props.open ? "\n    &{\n      border-bottom-left-radius: 0px !important;\n    }\n    &{\n      border-bottom-right-radius: 0px !important;\n    }\n  " : null;
}, function (props) {
  return props.variant === "default" ? "\n    box-shadow: " + (props.searchable && props.open ? "inset" : "") + " 0px 1px 2px #687FE262;\n    background-color: #ffffff;\n    border: 1px solid #CBCBCB;\n    color: " + _consts.BLACKPEARL + ";\n  " : props.variant === "charcoal" ? "\n    box-shadow: inset 0px 1px 2px #20283362;\n    background-color: #455262;\n    border: 1px solid #202833;\n    color: #FFFFFF;\n  " : null;
});

var ArrowContainer = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__ArrowContainer",
  componentId: "sc-tq1qi-3"
})(["\n  position: absolute;\n  content: \"\";\n  top: 10px;\n  right: 10px;\n  height: calc(100% - 20px);\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n"]);

var Arrow = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__Arrow",
  componentId: "sc-tq1qi-4"
})(["\n  width: 16px;\n  height: 16px;\n  transition: all 0.15s ease-in-out;\n\n\n  ", ";\n"], function (props) {
  return props.open ? "\n    transform: rotate(180deg);\n  " : "";
});

var Placeholder = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__Placeholder",
  componentId: "sc-tq1qi-5"
})(["\n  font-family: 'Be Vietnam Pro', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n\n  ", ";\n\n"], function (props) {
  return props.variant === "default" ? "\n    color: #dedede;\n  " : props.variant === "charcoal" ? "\n    color: #FFFFFF;\n  " : null;
});

var Options = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__Options",
  componentId: "sc-tq1qi-6"
})(["\n  position: absolute;\n  top: calc(100% - 1px);\n  left: 0;\n  right: 0;\n  z-index: 99;\n  box-shadow: 0px 1px 2px #687FE262;\n  border-top: 0px solid transparent;\n  border: 1px solid black;\n  border-bottom: 0px;\n\n  display: ", ";\n\n  ", ";\n\n\n  ", ";\n\n"], function (props) {
  return props.open ? "block" : "none";
}, function (props) {
  return props.maxHeight ? "\n    max-height: " + props.maxHeight + ";\n    overflow-y: auto;\n    overflow-x: hidden;\n  " : "";
}, function (props) {
  return props.variant === "default" ? "\n    background-color: #ffffff;\n    border-color: #CBCBCB;\n    color: ".concat(_consts.BLACKPEARL, ";\n  ") : props.variant === "charcoal" ? "\n    background-color: #455262;\n    border-color: #202833;\n    color: #FFFFFF;\n  " : null;
});

var Option = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__Option",
  componentId: "sc-tq1qi-7"
})(["\n  font-family: 'Be Vietnam Pro', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  padding: 0px 10px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  height: ", ";\n\n  ", ";\n\n\n\n"], function (props) {
  return props.height;
}, function (props) {
  return props.variant === "default" ? "\n    border-color: transparent transparent #CBCBCB;\n    &:hover{\n      background-color: " + _consts.LILAC + ";\n    }\n    background: " + (props.selected ? _consts.CHETWODEBLUE : "transparent") + "\n  " : props.variant === "charcoal" ? "\n    border-color: transparent transparent transparent; /*border-color: transparent transparent #202833;*/\n    &:hover{\n      background-color: rgba(0, 0, 0, 0.1);\n    }\n    background: " + (props.selected ? _consts.CHETWODEBLUE : "transparent") + "\n  " : null;
}); // const ClickCatcher = styled.div`
//   display: ${props => props.open ? "block" : "none"};
//   position: fixed;
//   top: 0px;
//   left: 0px;
//   width: 100%;
//   height: 100%;
// `;


var Label = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__Label",
  componentId: "sc-tq1qi-8"
})(["\n  margin-top: 20px;\n  margin-bottom: 5px;\n  font-size: 11px;\n  font-weight: 300;\n"]);

var Search = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__Search",
  componentId: "sc-tq1qi-9"
})(["\n  position: relative;\n  height: calc(", " - 2px);\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  border: 1px solid transparent;\n\n  ", ";\n"], function (props) {
  return props.height;
}, function (props) {
  return props.variant === "default" ? "\n    border-color: transparent transparent #CBCBCB;\n    background: ".concat(_consts.GHOSTWHITE, ";\n  ") : props.variant === "charcoal" ? "\n    border-color: transparent transparent transparent; /*border-color: transparent transparent #202833;*/\n    background: ".concat(_consts.BLACKPEARL, ";\n  ") : null;
});

var SearchIconContainer = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__SearchIconContainer",
  componentId: "sc-tq1qi-10"
})(["\n  position: absolute;\n  content: \"\";\n  top: 10px;\n  left: 8px;\n  height: calc(100% - 20px);\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n"]);

var SearchIcon = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__SearchIcon",
  componentId: "sc-tq1qi-11"
})(["\n  width: 20px;\n  height: 20px;\n"]);

var SearchInput = _styledComponents.default.input.withConfig({
  displayName: "OzSelect__SearchInput",
  componentId: "sc-tq1qi-12"
})(["\n  position: absolute;\n  top: 0px;\n  ", ": 0px;\n  font-family: 'Be Vietnam Pro', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n  padding: 0px 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  letter-spacing: inherit;\n  outline: none;\n  width: calc(100% - 24px);\n  border: 0px;\n  background-color: transparent;\n  height: calc(", " - 4px);\n\n  ", ";\n"], function (props) {
  return props.open ? "right" : "left";
}, function (props) {
  return props.height;
}, function (props) {
  return props.variant === "default" ? "\n    color: " + (props.disabled ? "#30303054" : _consts.BLACKPEARL) + ";\n    ::placeholder {\n      color: #dedede;\n      opacity: 1;\n    }\n    :-webkit-autofill {\n      box-shadow: inset 0 0 0px 9999px #ffffff;\n    }\n  " : props.variant === "charcoal" ? "\n      color: " + (props.disabled ? "#30303054" : "#FFFFFF") + ";\n      ::placeholder {\n        color: #FFFFFF;\n        opacity: 1;\n      }\n      :-webkit-autofill {\n        box-shadow: inset 0 0 0px 9999px #ffffff;\n      }\n  " : null;
});

var Clear = _styledComponents.default.div.withConfig({
  displayName: "OzSelect__Clear",
  componentId: "sc-tq1qi-13"
})(["\n  z-index: 999;\n  cursor: pointer;\n  position: absolute;\n  top: 6px;\n  right: 8px;\n  width: calc(", " - 16px);\n  height: calc(", " - 16px);\n  background-color: ", ";\n  border-radius: 3px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n\n  /* box-shadow: 0px 1px 2px #687FE239; */\n\n  &:hover{\n    box-shadow: inset 0px 1px 2px #687FE239;\n  }\n"], function (props) {
  return props.height;
}, function (props) {
  return props.height;
}, _consts.LILAC);

var OzSelect = function OzSelect(_ref) {
  var label = _ref.label,
      placeholder = _ref.placeholder,
      _ref$searchPlaceholde = _ref.searchPlaceholder,
      searchPlaceholder = _ref$searchPlaceholde === void 0 ? "Search" : _ref$searchPlaceholde,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? [] : _ref$values,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? null : _ref$selected,
      width = _ref.width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "34px" : _ref$height,
      maxHeight = _ref.maxHeight,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? null : _ref$onChange,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      searchable = _ref.searchable,
      _ref$onSearch = _ref.onSearch,
      onSearch = _ref$onSearch === void 0 ? function () {} : _ref$onSearch;

  var _useState = (0, _react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = (0, _react.useState)(""),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      isFocus = _useState3[0],
      setFocus = _useState3[1];

  var _useState4 = (0, _react.useState)(null),
      indexSelected = _useState4[0],
      setIndexSelected = _useState4[1];

  var containerRef = (0, _react.useRef)(null);
  var searchRef = (0, _react.useRef)(null);
  var iconColor = _consts.BLACKPEARL;

  switch (variant) {
    case "charcoal":
      iconColor = "#FFFFFF";
      break;

    default:
      break;
  }

  (0, _react.useEffect)(function () {
    function handler(e) {
      var newIndex;

      if (isFocus) {
        switch (e.keyCode) {
          case 9:
            //Tab
            break;

          case 16:
            //Shift
            break;

          case 38:
            //ArrowUp
            e.preventDefault();

            if (!open) {
              setOpen(true);
            }

            if (indexSelected === null || indexSelected === 0) {
              newIndex = values.length - 1;
            } else {
              newIndex = indexSelected - 1;
            }

            setIndexSelected(newIndex);
            break;

          case 40:
            //ArrowDown
            e.preventDefault();

            if (!open) {
              setOpen(true);
            }

            if (indexSelected !== null && indexSelected < values.length - 1) {
              newIndex = indexSelected + 1;
            } else {
              newIndex = 0;
            }

            setIndexSelected(newIndex);
            break;

          case 13:
            //Enter
            e.preventDefault();
            setOpen(false);
            setSearch("");

            if (onSearch) {
              onSearch("");
            }

            ;

            if (onChange) {
              onChange(values[indexSelected].value);
            }

            setIndexSelected(null);
            break;

          case 27:
            //Escape
            e.preventDefault(); // containerRef.current.focus();ado

            setOpen(false);
            setSearch("");

            if (onSearch) {
              onSearch("");
            }

            ;
            setIndexSelected(null);
            break;

          default:
            if (!open) {
              setOpen(true);
            }

            searchRef.current.focus();
            break;
        }
      }
    }

    window.addEventListener('keydown', handler);
    return function () {
      window.removeEventListener('keydown', handler);
    };
  }, [isFocus, indexSelected, values, onChange, onSearch, open]);
  return __jsx(Wrapper, null, label ? __jsx(Label, null, label, " ", required ? "*" : "") : null, __jsx(Container, {
    ref: containerRef,
    width: width ? width : "260px",
    isFocus: isFocus,
    onBlur: function onBlur(e) {
      // console.log("ONBLUR WRAPPER")
      // console.log(e);
      // console.log(e.target);
      // console.log(e.relatedTarget);
      if (!containerRef.current.contains(e.relatedTarget)) {
        setTimeout(function () {
          setFocus(false);
          setSearch("");

          if (onSearch) {
            onSearch("");
          }

          ;
          setOpen(false);
          setIndexSelected(null);
        }, 200);
      }
    }
  }, __jsx(Selected, {
    height: height,
    variant: variant,
    onClick: function onClick() {
      setOpen(true);
    },
    selected: selected,
    searchable: searchable,
    open: open,
    tabIndex: "0",
    onFocus: function onFocus() {
      setFocus(true);
      setOpen(true);
    }
  }, values.filter(function (item) {
    return item.value === selected;
  }).length > 0 ? values.filter(function (item) {
    return item.value === selected;
  })[0].name : __jsx(Placeholder, {
    variant: variant
  }, placeholder), __jsx(ArrowContainer, null, __jsx(Arrow, {
    open: open
  }, __jsx(_OzIcon.default, {
    size: "16px",
    name: "arrow-down",
    color: iconColor
  })))), __jsx(Options, {
    variant: variant,
    open: open,
    maxHeight: maxHeight ? maxHeight : null
  }, searchable ? __jsx(Search, {
    height: height,
    variant: variant
  }, __jsx(SearchIconContainer, null, __jsx(SearchIcon, null, __jsx(_OzIcon.default, {
    name: "search",
    color: iconColor
  }))), __jsx(SearchInput, {
    ref: searchRef,
    height: height,
    open: open,
    variant: variant,
    onChange: function onChange(e) {
      setSearch(e.target.value);

      if (onSearch) {
        onSearch(e.target.value);
      }

      ;
    },
    value: search,
    placeholder: searchPlaceholder,
    tabIndex: "-1"
  }), search !== "" ? __jsx(Clear, {
    height: height,
    onClick: function onClick() {
      setSearch("");

      if (onSearch) {
        onSearch("");
      }

      ;
    }
  }, __jsx(_OzIcon.default, {
    size: "14px",
    name: "x",
    color: iconColor
  })) : null) : null, values.map(function (item, i) {
    return __jsx(Option, {
      height: height,
      variant: variant,
      key: i,
      onClick: function onClick(e) {
        // console.log(e);
        // setOpen(false);
        // setIndexSelected(null);
        // setSearch("");
        // if(onSearch){onSearch("")};
        if (onChange) {
          onChange(item.value);
        }
      },
      selected: indexSelected === i
    }, item.name);
  }))));
};

var _default = OzSelect;
exports.default = _default;